export default class MrtMath {
    static clamp(value, min, max) {
        if (!value) {
            return 0;
        }
        return Math.max(min, Math.min(max, value));
    }
}
